import { Component, OnInit, HostListener, ViewChild, OnDestroy, ViewChildren, ElementRef, QueryList } from '@angular/core';
import { ApiServiceService } from '../../services/api-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SearchServiceService } from '../../services/search-service.service';
import { Title, Meta } from '@angular/platform-browser';
import { LoaderService } from '../../services/loader.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { FiltersModalComponent } from '../filters-modal/filters-modal.component';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss']
})
export class ProductListComponent implements OnInit, OnDestroy {
  allProduct: any[] = [];
  allProductFilter: any[] = [];
  productCatId: any;
  filterProducts: any;
  brandName: any;
  priceRange = 10000;
  brands: any[] = [];
  selectedBrands: Set<string> = new Set();
  selectedColors: Set<string> = new Set();
  selectedDiscounts: Set<string> = new Set();
  colors: any[] = [];
  discounts: any[] = [];
  discount: any;
  filteredCategories: any;
  isLoading: boolean = true;
  sortOrder: string = '';
  searchTerm: string = '';
  
 showAllBrands = false;
  currentPage = 1;
  itemsPerPage = 12;
  isLoadingMore = false;
  hasMoreItems = true;
  private scrollSubject = new Subject<Event>();
  private subscriptions: Subscription[] = [];

  // // ✅ ADD THIS
  // @ViewChildren('productCard') cards!: QueryList<ElementRef>;

  // private viewed = new Set<string>();

  priceRanges = [
    { label: 'Under ₹500', min: 0, max: 499 },
    { label: '₹500 - ₹1,000', min: 500, max: 1000 },
    { label: '₹1,000 - ₹2,500', min: 1000, max: 2500 },
    { label: '₹2,500 - ₹5,000', min: 2500, max: 5000 },
    { label: 'Over ₹5,000', min: 5000, max: Number.MAX_SAFE_INTEGER },
  ];
  selectedPriceRanges: Set<any> = new Set();

  discountRanges = [
    { label: 'Up to 25%', min: 0, max: 25 },
    { label: '26% - 50%', min: 26, max: 50 },
    { label: '51% - 75%', min: 51, max: 75 },
    { label: '76% and above', min: 76, max: 100 }
  ];

  isSticky: boolean = false;
  isMobileOrTablet = false;
  @ViewChild('filtersModal') filtersModal!: FiltersModalComponent;
  suggestProduct: any;

  constructor(
    private api: ApiServiceService,
    private router: Router,
    private activeRouter: ActivatedRoute,
    private searchApi: SearchServiceService,
    private titleService: Title,
    private metaService: Meta,
    private Loader: LoaderService,
    private breakpointObserver: BreakpointObserver
  ) {}

  ngOnInit() {

    this.setupScrollListener();
   this.activeRouter.queryParams.subscribe((params: any) => {
  const newSearchTerm = (params['search'] || '').trim();

  if (newSearchTerm && newSearchTerm !== this.searchTerm) {
    // New search term found
    this.searchTerm = newSearchTerm;
    this.currentPage = 1;
    this.allProduct = [];
    this.allProductFilter = [];
    this.fetchAllProductsBySearch(this.searchTerm); // Load all matched products
    // this.similarSuggetionProduct(this.searchTerm); // Load all matched products
  } else if (!newSearchTerm && this.searchTerm) {
    // Search cleared
    this.searchTerm = '';
    this.resetFilters();
    this.currentPage = 1;
    this.allProduct = [];
    this.allProductFilter = [];
    this.getProductByCatId(this.productCatId); // Load default product list
  } else if (!newSearchTerm && !this.searchTerm && this.productCatId) {
    // Initial load or reload without search
    this.getProductByCatId(this.productCatId);
  }
});
    this.resetFilters();


    // this.activeRouter.params.subscribe((data: any) => {
    //   this.productCatId = data['id'];
    //   if (this.productCatId === undefined) {
    //     let product = window.history.state;
    //     if (product && product[0]) {
    //       Object.keys(product).forEach(key => {
    //         if (product[key] && typeof product[key] === 'object') {
    //           this.allProduct.push(product[key]);
    //         }
    //       });
    //       this.allProductFilter = [...this.allProduct];
    //       this.extractFilters();
    //     }
    //   } else {
    //     this.getProductByCatId(this.productCatId);
    //   }
    // });
this.activeRouter.params.subscribe((data: any) => {
  this.productCatId = data['id'];

  if (this.productCatId !== undefined) {
    // Reset pagination and products before fetching
    this.currentPage = 1;
    this.allProduct = [];
    this.allProductFilter = [];
    this.getProductByCatId(this.productCatId);
  } else {
    let product = window.history.state;
    if (product && product[0]) {
      Object.keys(product).forEach(key => {
        if (product[key] && typeof product[key] === 'object') {
          this.allProduct.push(product[key]);
        }
      });
      this.allProductFilter = [...this.allProduct];
      this.extractFilters();
    }
  }
});

    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras?.state) {
      this.discount = navigation.extras.state['discount'];
    }

    this.breakpointObserver
      .observe([Breakpoints.Handset, Breakpoints.Tablet])
      .subscribe((result) => {
        this.isMobileOrTablet = result.matches;
      });

  }



//   ngAfterViewInit() {
//   const observer = new IntersectionObserver(entries => {
//     entries.forEach(entry => {
//       if (entry.isIntersecting) {
//         const productId = entry.target.getAttribute('data-id');

//         if (productId && !this.viewed.has(productId)) {
//           this.viewed.add(productId);
//           this.api.productImpression(productId).subscribe();
//         }
//       }
//     });
//   }, { threshold: 0.5 });

//   this.cards.forEach(card => observer.observe(card.nativeElement));
// }


  ngOnDestroy() {
    this.scrollSubject.complete();
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  setupScrollListener() {
    const scrollSub = this.scrollSubject.pipe(
      debounceTime(200)
    ).subscribe(event => this.onScroll(event));
    this.subscriptions.push(scrollSub);
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event: Event) {
    this.scrollSubject.next(event);
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.isSticky = scrollTop > 100;
  }

  onScroll(event: Event): void {
    if (this.isLoadingMore || !this.hasMoreItems) return;
    
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const scrollPosition = window.scrollY || window.pageYOffset || 
                         document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);
    
    if (documentHeight - (scrollPosition + windowHeight) < 600) {
      this.loadMoreProducts();
    }
  }

loadMoreProducts() {
  if (this.isLoadingMore || !this.hasMoreItems) return;
  this.isLoadingMore = true;
  this.currentPage++;

  if (this.searchTerm) {
    this.fetchSearchResults(this.searchTerm); // Load next 12 items
  } else if (this.productCatId) {
    this.getProductByCatId(this.productCatId); // Load next 12 items
  } else {
    this.isLoadingMore = false;
  }
}

  extractFilters() {
    this.brands = Array.from(new Set(this.allProduct.map(product => product?.productDetails?.brand)));
    this.colors = Array.from(new Set(this.allProduct.flatMap(product => 
      product?.variants?.map((variants: any) => variants?.color) || []
    )));
    this.discounts = this.discountRanges.map(range => range.label);
  }

  openFiltersModal(): void {
    this.filtersModal.openModal();
  }

  onFiltersModalClose(): void {
  }

  onFilterSelect(): void {
    this.applyFilters();
  }

  fetchSearchResults(search: string): void {
    this.isLoading = true;
    const sub = this.api.searchProducts(search, this.currentPage, this.itemsPerPage).subscribe({
      next: (response: any) => {
        const newProducts = response.products || [];
        
        if (this.currentPage === 1) {
          this.allProduct = newProducts;
          this.allProductFilter = [...newProducts];
        } else {
          this.allProduct = [...this.allProduct, ...newProducts];
          this.allProductFilter = [...this.allProduct];
        }
        
        this.hasMoreItems = newProducts.length === this.itemsPerPage;
        this.isLoading = false;
        this.isLoadingMore = false;
        this.extractFilters();
        
      },
      error: (error: any) => {
        console.error('Error fetching search results:', error);
        this.isLoading = false;
        this.isLoadingMore = false;
      }
    });
    this.subscriptions.push(sub);
  }


fetchAllProductsBySearch(searchTerm: string): void {
  this.isLoading = true;
  let currentPage = 1;
  let allProducts: any[] = [];

  const fetchPage = () => {
    this.api.searchProducts(searchTerm, currentPage, 50).subscribe({
      next: (response: any) => {
        const newProducts = response.products || [];
        allProducts = [...allProducts, ...newProducts];

        if (response.products.length === 50) {
          currentPage++;
          fetchPage(); // Keep fetching until all pages loaded
        } else {
          this.allProduct = allProducts;
          this.allProductFilter = [...allProducts];
          this.extractFilters();
          this.applyFilters();
          this.isLoading = false;


          if (this.allProductFilter.length === 0) {
            this.similarSuggetionProduct(searchTerm);
          }
        }
      },
      error: (error) => {
        console.error('Error fetching all search results:', error);
        this.isLoading = false;
      }
    });
  };

  fetchPage();
}

similarSuggetionProduct(searchTerm: string): void {
  this.api.searchSuggestions(searchTerm).subscribe({
    next: (res) => {
      this.suggestProduct = res?.similarProducts || [];
      console.log('🟣 Suggestion products:', this.suggestProduct);
    },
    error: (err) => {
      console.error('Error fetching suggested products:', err);
    }
  });
}

  
  getProductByCatId(catName: any) {
    this.Loader.showLoader();
    const sub = this.api.getProductsByCategory(this.productCatId, this.currentPage, this.itemsPerPage).subscribe({
      next: (product: any) => {
        const newProducts = product.data || [];
       if (this.currentPage === 1) {
  this.allProduct = [...newProducts];
} else {
  this.allProduct = [...this.allProduct, ...newProducts];
}
this.allProductFilter = [...this.allProduct];

        
        this.hasMoreItems = newProducts.length === this.itemsPerPage;
        this.Loader.hideLoader();
        this.isLoadingMore = false;
        this.extractFilters();
      },
      error: (error: any) => {
        if (error.status === 404) {
          this.allProduct = [];
          this.allProductFilter = [];
          console.error(error.error.message);
        }
        this.Loader.hideLoader();
        this.isLoadingMore = false;
      }
    });
    this.subscriptions.push(sub);
  }

  productDetails(product: any) {
    if (product._id) {
    this.router.navigate(['product-details', product._id], { state: { product } });
      this.api.productClick(product._id).subscribe();
     } else if (product.slug) {
      // SEO-friendly route using slug
    const cleanSlug = product.slug.replace(/\s+/g, '-');
      this.api.productClick(product._id).subscribe();
    this.router.navigate(['/', cleanSlug]);

     }
  }

  applyFilters() {
    this.allProductFilter = this.allProduct.filter(product => {
      const matchesBrand = this.selectedBrands.size ? this.selectedBrands.has(product?.productDetails?.brand) : true;
      const matchesColor = this.selectedColors.size 
        ? product?.variants?.some((variants: any) => this.selectedColors.has(variants?.color)) 
        : true;

      const matchesDiscount = this.selectedDiscounts.size
        ? Array.from(this.selectedDiscounts).some(selectedDiscount => {
            const mrp = product?.priceInventoryShippingInfo?.MRP;
            const sellingPrice = product?.priceInventoryShippingInfo?.sellingPrice;
            const discount = mrp && sellingPrice ? ((mrp - sellingPrice) / mrp) * 100 : 0;

            // Find the range that matches the selected discount label
            const range = this.discountRanges.find(range => range.label === selectedDiscount);
            if (range) {
              return discount >= range.min && discount <= range.max;
            }
            return false;
          })
        : true;

      const matchesPrice = this.selectedPriceRanges.size
        ? Array.from(this.selectedPriceRanges).some(range => product.priceInventoryShippingInfo.sellingPrice >= range.min && product.priceInventoryShippingInfo.sellingPrice <= range.max)
        : true;

      return matchesBrand && matchesColor && matchesDiscount && matchesPrice;
    });

    if (this.sortOrder) {
      this.sortProductsByPrice(this.sortOrder);
    }
  }

  togglePriceRange(range: any) {
    if (this.selectedPriceRanges.has(range)) {
      this.selectedPriceRanges.delete(range);
    } else {
      this.selectedPriceRanges.add(range);
    }
    this.applyFilters();
  }

    get visibleBrands() {
    return this.showAllBrands ? this.brands : this.brands.slice(0, 5);
  }

   toggleShowMore() {
    this.showAllBrands = !this.showAllBrands;
  }

  toggleBrand(brand: string) {
    if (this.selectedBrands.has(brand)) {
      this.selectedBrands.delete(brand);
    } else {
      this.selectedBrands.add(brand);
    }
    this.applyFilters();
  }

  toggleColor(color: string) {
    if (this.selectedColors.has(color)) {
      this.selectedColors.delete(color);
    } else {
      this.selectedColors.add(color);
    }
    this.applyFilters();
  }

  toggleDiscount(discount: string) {
    if (this.selectedDiscounts.has(discount)) {
      this.selectedDiscounts.delete(discount);
    } else {
      this.selectedDiscounts.add(discount);
    }
    this.applyFilters();
  }

  onPriceRangeChange() {
    this.applyFilters();
  }

  resetFilters() {
    this.selectedBrands.clear();
    this.selectedColors.clear();
    this.selectedDiscounts.clear();
    this.selectedPriceRanges.clear();
    this.sortOrder = '';
    this.priceRange = 10000;
    this.applyFilters();
  }

  onSearch() {
    const lowerCaseSearchTerm = this.searchTerm.toLowerCase();
    if (this.searchTerm) {
      this.filteredCategories = this.allProduct.filter(product => {
        
        const productName = product?.productDetails?.productName.toLowerCase() || '';
        const keywords = product.meta_keywords?.toLowerCase() || '';
        const name = product.product_name?.toLowerCase() || '';
        return productName.includes(lowerCaseSearchTerm) ||
               keywords.includes(lowerCaseSearchTerm) ||
               name.includes(lowerCaseSearchTerm);
      });
    } else {
      this.filteredCategories = this.allProduct;
    }
  }

  sortProductsByPrice(order: string) {
    if (order === 'lowToHigh') {
      this.allProductFilter.sort((a, b) => a.priceInventoryShippingInfo.sellingPrice - b.priceInventoryShippingInfo.sellingPrice);
    } else if (order === 'highToLow') {
      this.allProductFilter.sort((a, b) => b.priceInventoryShippingInfo.sellingPrice - a.priceInventoryShippingInfo.sellingPrice);
    }
  }

  onSortOrderChange(event: any) {
    this.sortOrder = event.target.value;
    this.applyFilters();
  }

 

}


// import { Component, OnInit, HostListener, ViewChild, OnDestroy } from '@angular/core';
// import { ApiServiceService } from '../../services/api-service.service';
// import { ActivatedRoute, Router } from '@angular/router';
// import { SearchServiceService } from '../../services/search-service.service';
// import { Title, Meta } from '@angular/platform-browser';
// import { LoaderService } from '../../services/loader.service';
// import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
// import { FiltersModalComponent } from '../filters-modal/filters-modal.component';
// import { Subject, Subscription } from 'rxjs';
// import { debounceTime } from 'rxjs/operators';

// @Component({
//   selector: 'app-product-list',
//   templateUrl: './product-list.component.html',
//   styleUrls: ['./product-list.component.scss']
// })
// export class ProductListComponent implements OnInit, OnDestroy {
//   allProduct: any[] = [];
//   allProductFilter: any[] = [];
//   productCatId: any;
//   filterProducts: any;
//   brandName: any;
//   priceRange = 10000;
//   brands: any[] = [];
//   selectedBrands: Set<string> = new Set();
//   selectedColors: Set<string> = new Set();
//   selectedDiscounts: Set<string> = new Set();
//   colors: any[] = [];
//   discounts: any[] = [];
//   discount: any;
//   filteredCategories: any;
//   isLoading: boolean = true;
//   sortOrder: string = '';
//   searchTerm: string = '';
  

//   currentPage = 1;
//   itemsPerPage = 12;
//   isLoadingMore = false;
//   hasMoreItems = true;
//   private scrollSubject = new Subject<Event>();
//   private subscriptions: Subscription[] = [];

//   priceRanges = [
//     { label: 'Under ₹500', min: 0, max: 499 },
//     { label: '₹500 - ₹1,000', min: 500, max: 1000 },
//     { label: '₹1,000 - ₹2,500', min: 1000, max: 2500 },
//     { label: '₹2,500 - ₹5,000', min: 2500, max: 5000 },
//     { label: 'Over ₹5,000', min: 5000, max: Number.MAX_SAFE_INTEGER },
//   ];
//   selectedPriceRanges: Set<any> = new Set();

//   discountRanges = [
//     { label: 'Up to 25%', min: 0, max: 25 },
//     { label: '26% - 50%', min: 26, max: 50 },
//     { label: '51% - 75%', min: 51, max: 75 },
//     { label: '76% and above', min: 76, max: 100 }
//   ];

//   isSticky: boolean = false;
//   isMobileOrTablet = false;
//   @ViewChild('filtersModal') filtersModal!: FiltersModalComponent;
//   suggestProduct: any;

//   constructor(
//     private api: ApiServiceService,
//     private router: Router,
//     private activeRouter: ActivatedRoute,
//     private searchApi: SearchServiceService,
//     private titleService: Title,
//     private metaService: Meta,
//     private Loader: LoaderService,
//     private breakpointObserver: BreakpointObserver
//   ) {}

//   ngOnInit() {
//     this.setupScrollListener();
//    this.activeRouter.queryParams.subscribe((params: any) => {
//   const newSearchTerm = (params['search'] || '').trim();

//   if (newSearchTerm && newSearchTerm !== this.searchTerm) {
//     // New search term found
//     this.searchTerm = newSearchTerm;
//     this.currentPage = 1;
//     this.allProduct = [];
//     this.allProductFilter = [];
//     this.fetchAllProductsBySearch(this.searchTerm); // Load all matched products
//     this.similarSuggetionProduct(this.searchTerm); // Load all matched products
//   } else if (!newSearchTerm && this.searchTerm) {
//     // Search cleared
//     this.searchTerm = '';
//     this.resetFilters();
//     this.currentPage = 1;
//     this.allProduct = [];
//     this.allProductFilter = [];
//     this.getProductByCatId(this.productCatId); // Load default product list
//   } else if (!newSearchTerm && !this.searchTerm && this.productCatId) {
//     // Initial load or reload without search
//     this.getProductByCatId(this.productCatId);
//   }
// });
//     this.resetFilters();
//     this.activeRouter.params.subscribe((data: any) => {
//       this.productCatId = data['id'];
//       if (this.productCatId === undefined) {
//         let product = window.history.state;
//         if (product && product[0]) {
//           Object.keys(product).forEach(key => {
//             if (product[key] && typeof product[key] === 'object') {
//               this.allProduct.push(product[key]);
//             }
//           });
//           this.allProductFilter = [...this.allProduct];
//           this.extractFilters();
//         }
//       } else {
//         this.getProductByCatId(this.productCatId);
//       }
//     });

//     const navigation = this.router.getCurrentNavigation();
//     if (navigation?.extras?.state) {
//       this.discount = navigation.extras.state['discount'];
//     }

//     this.breakpointObserver
//       .observe([Breakpoints.Handset, Breakpoints.Tablet])
//       .subscribe((result) => {
//         this.isMobileOrTablet = result.matches;
//       });
//   }

//   ngOnDestroy() {
//     this.scrollSubject.complete();
//     this.subscriptions.forEach(sub => sub.unsubscribe());
//   }

//   setupScrollListener() {
//     const scrollSub = this.scrollSubject.pipe(
//       debounceTime(200)
//     ).subscribe(event => this.onScroll(event));
//     this.subscriptions.push(scrollSub);
//   }

//   @HostListener('window:scroll', ['$event'])
//   onWindowScroll(event: Event) {
//     this.scrollSubject.next(event);
//     const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
//     this.isSticky = scrollTop > 100;
//   }

//   onScroll(event: Event): void {
//     if (this.isLoadingMore || !this.hasMoreItems) return;
    
//     const windowHeight = window.innerHeight;
//     const documentHeight = document.documentElement.scrollHeight;
//     const scrollPosition = window.scrollY || window.pageYOffset || 
//                          document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);
    
//     if (documentHeight - (scrollPosition + windowHeight) < 600) {
//       this.loadMoreProducts();
//     }
//   }

// loadMoreProducts() {
//   if (this.isLoadingMore || !this.hasMoreItems) return;
//   this.isLoadingMore = true;
//   this.currentPage++;

//   if (this.searchTerm) {
//     this.fetchSearchResults(this.searchTerm); // Load next 12 items
//   } else if (this.productCatId) {
//     this.getProductByCatId(this.productCatId); // Load next 12 items
//   } else {
//     this.isLoadingMore = false;
//   }
// }

//   extractFilters() {
//     this.brands = Array.from(new Set(this.allProduct.map(product => product?.productDetails?.brand)));
//     this.colors = Array.from(new Set(this.allProduct.flatMap(product => 
//       product?.variants?.map((variants: any) => variants?.color) || []
//     )));
//     this.discounts = this.discountRanges.map(range => range.label);
//   }

//   openFiltersModal(): void {
//     this.filtersModal.openModal();
//   }

//   onFiltersModalClose(): void {
//   }

//   onFilterSelect(): void {
//     this.applyFilters();
//   }

//   fetchSearchResults(search: string): void {
//     this.isLoading = true;
//     const sub = this.api.searchProducts(search, this.currentPage, this.itemsPerPage).subscribe({
//       next: (response: any) => {
//         const newProducts = response.products || [];
        
//         if (this.currentPage === 1) {
//           this.allProduct = newProducts;
//           this.allProductFilter = [...newProducts];
//         } else {
//           this.allProduct = [...this.allProduct, ...newProducts];
//           this.allProductFilter = [...this.allProduct];
//         }
        
//         this.hasMoreItems = newProducts.length === this.itemsPerPage;
//         this.isLoading = false;
//         this.isLoadingMore = false;
//         this.extractFilters();
//       },
//       error: (error: any) => {
//         console.error('Error fetching search results:', error);
//         this.isLoading = false;
//         this.isLoadingMore = false;
//       }
//     });
//     this.subscriptions.push(sub);
//   }


// fetchAllProductsBySearch(searchTerm: string): void {
//   this.isLoading = true;
//   let currentPage = 1;
//   let allProducts: any[] = [];

//   const fetchPage = () => {
//     this.api.searchProducts(searchTerm, currentPage, 50).subscribe({
//       next: (response: any) => {
//         allProducts = [...allProducts, ...response.products];

//         if (response.products.length === 50) {
//           currentPage++;
//           fetchPage(); // Load next page
//         } else {
//           this.allProduct = allProducts;
//           this.allProductFilter = [...allProducts];
//           this.extractFilters();
//           this.applyFilters();
//           this.isLoading = false;
//         }
//       },
//       error: (error) => {
//         console.error('Error fetching all search results:', error);
//         this.isLoading = false;
//       }
//     });
//   };

//   fetchPage();
// }


// similarSuggetionProduct(searchTerm: string): void {
// if(this.allProductFilter.length <= 0){
//     this.api.searchSuggestions(searchTerm).subscribe({
//        next: (res) => {
//           this.suggestProduct = res.data?.products;
//           console.log('suggestProduct--->' ,this.suggestProduct)
//         }
// })
// }
//   }
  
//   getProductByCatId(catName: any) {
//     this.Loader.showLoader();
//     const sub = this.api.getProductsByCategory(this.productCatId, this.currentPage, this.itemsPerPage).subscribe({
//       next: (product: any) => {
//         const newProducts = product.data || [];
//         if (this.currentPage === 1) {
//           this.allProduct = newProducts;
//           this.allProductFilter = [...newProducts];
//         } else {
//           this.allProduct = [...this.allProduct, ...newProducts];
//           this.allProductFilter = [...this.allProduct];
//         }
        
//         this.hasMoreItems = newProducts.length === this.itemsPerPage;
//         this.Loader.hideLoader();
//         this.isLoadingMore = false;
//         this.extractFilters();
//       },
//       error: (error: any) => {
//         if (error.status === 404) {
//           this.allProduct = [];
//           this.allProductFilter = [];
//           console.error(error.error.message);
//         }
//         this.Loader.hideLoader();
//         this.isLoadingMore = false;
//       }
//     });
//     this.subscriptions.push(sub);
//   }

//   productDetails(product: any) {
//     this.router.navigate(['product-details', product._id], { state: { product } });
//   }

//   applyFilters() {
//     this.allProductFilter = this.allProduct.filter(product => {
//       const matchesBrand = this.selectedBrands.size ? this.selectedBrands.has(product?.productDetails?.brand) : true;
//       const matchesColor = this.selectedColors.size 
//         ? product?.variants?.some((variants: any) => this.selectedColors.has(variants?.color)) 
//         : true;

//       const matchesDiscount = this.selectedDiscounts.size
//         ? Array.from(this.selectedDiscounts).some(selectedDiscount => {
//             const mrp = product?.priceInventoryShippingInfo?.MRP;
//             const sellingPrice = product?.priceInventoryShippingInfo?.sellingPrice;
//             const discount = mrp && sellingPrice ? ((mrp - sellingPrice) / mrp) * 100 : 0;

//             // Find the range that matches the selected discount label
//             const range = this.discountRanges.find(range => range.label === selectedDiscount);
//             if (range) {
//               return discount >= range.min && discount <= range.max;
//             }
//             return false;
//           })
//         : true;

//       const matchesPrice = this.selectedPriceRanges.size
//         ? Array.from(this.selectedPriceRanges).some(range => product.priceInventoryShippingInfo.sellingPrice >= range.min && product.priceInventoryShippingInfo.sellingPrice <= range.max)
//         : true;

//       return matchesBrand && matchesColor && matchesDiscount && matchesPrice;
//     });

//     if (this.sortOrder) {
//       this.sortProductsByPrice(this.sortOrder);
//     }
//   }

//   togglePriceRange(range: any) {
//     if (this.selectedPriceRanges.has(range)) {
//       this.selectedPriceRanges.delete(range);
//     } else {
//       this.selectedPriceRanges.add(range);
//     }
//     this.applyFilters();
//   }

//   toggleBrand(brand: string) {
//     if (this.selectedBrands.has(brand)) {
//       this.selectedBrands.delete(brand);
//     } else {
//       this.selectedBrands.add(brand);
//     }
//     this.applyFilters();
//   }

//   toggleColor(color: string) {
//     if (this.selectedColors.has(color)) {
//       this.selectedColors.delete(color);
//     } else {
//       this.selectedColors.add(color);
//     }
//     this.applyFilters();
//   }

//   toggleDiscount(discount: string) {
//     if (this.selectedDiscounts.has(discount)) {
//       this.selectedDiscounts.delete(discount);
//     } else {
//       this.selectedDiscounts.add(discount);
//     }
//     this.applyFilters();
//   }

//   onPriceRangeChange() {
//     this.applyFilters();
//   }

//   resetFilters() {
//     this.selectedBrands.clear();
//     this.selectedColors.clear();
//     this.selectedDiscounts.clear();
//     this.selectedPriceRanges.clear();
//     this.sortOrder = '';
//     this.priceRange = 10000;
//     this.applyFilters();
//   }

//   onSearch() {
//     const lowerCaseSearchTerm = this.searchTerm.toLowerCase();
//     if (this.searchTerm) {
//       this.filteredCategories = this.allProduct.filter(product => {
        
//         const productName = product?.productDetails?.productName.toLowerCase() || '';
//         const keywords = product.meta_keywords?.toLowerCase() || '';
//         const name = product.product_name?.toLowerCase() || '';
//         return productName.includes(lowerCaseSearchTerm) ||
//                keywords.includes(lowerCaseSearchTerm) ||
//                name.includes(lowerCaseSearchTerm);
//       });
//     } else {
//       this.filteredCategories = this.allProduct;
//     }
//   }

//   sortProductsByPrice(order: string) {
//     if (order === 'lowToHigh') {
//       this.allProductFilter.sort((a, b) => a.priceInventoryShippingInfo.sellingPrice - b.priceInventoryShippingInfo.sellingPrice);
//     } else if (order === 'highToLow') {
//       this.allProductFilter.sort((a, b) => b.priceInventoryShippingInfo.sellingPrice - a.priceInventoryShippingInfo.sellingPrice);
//     }
//   }

//   onSortOrderChange(event: any) {
//     this.sortOrder = event.target.value;
//     this.applyFilters();
//   }

 

// }


